(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["batanova-duyuru"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-duyuru')) {
    class BtDuyuru extends HTMLElement {
      connectedCallback() {
        this.mesajlar = Array.from(this.querySelectorAll('.bt-duyuru__mesaj'));
        this.sira = 0;
        this.sure = Number(this.dataset.sure) || 5000;
        this.azHareket = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.mesajlar.length < 2) return;

        this.querySelectorAll('.bt-duyuru__ok').forEach((ok) => {
          ok.addEventListener('click', () => {
            this.git(this.sira + Number(ok.dataset.yon));
            this.baslat();
          });
        });

        this.addEventListener('mouseenter', () => this.durdur());
        this.addEventListener('mouseleave', () => this.baslat());
        this.addEventListener('focusin', () => this.durdur());
        this.addEventListener('focusout', () => this.baslat());
        document.addEventListener('visibilitychange', () => (document.hidden ? this.durdur() : this.baslat()));

        this.baslat();
      }

      disconnectedCallback() {
        this.durdur();
      }

      baslat() {
        this.durdur();
        if (this.azHareket || this.mesajlar.length < 2) return;
        this.zamanlayici = setInterval(() => this.git(this.sira + 1), this.sure);
      }

      durdur() {
        clearInterval(this.zamanlayici);
      }

      git(hedef) {
        const n = this.mesajlar.length;
        const yeni = ((hedef % n) + n) % n;
        if (yeni === this.sira) return;
        const eski = this.mesajlar[this.sira];
        const gelen = this.mesajlar[yeni];

        eski.classList.remove('is-aktif');
        eski.classList.add('is-cikan');
        eski.setAttribute('aria-hidden', 'true');
        eski.querySelector('a')?.setAttribute('tabindex', '-1');
        setTimeout(() => eski.classList.remove('is-cikan'), 700);

        gelen.classList.remove('is-cikan');
        gelen.classList.add('is-aktif');
        gelen.removeAttribute('aria-hidden');
        gelen.querySelector('a')?.removeAttribute('tabindex');
        this.sira = yeni;
      }

    }
    customElements.define('bt-duyuru', BtDuyuru);

    document.addEventListener('shopify:block:select', (e) => {
      const kap = e.target.closest('bt-duyuru');
      if (!kap) return;
      const index = Array.from(kap.querySelectorAll('.bt-duyuru__mesaj')).indexOf(e.target);
      kap.durdur();
      if (index > -1) kap.git(index);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function kur(kok) {
      (kok || document).querySelectorAll('.bt-footer__dev:not(.is-gorunur)').forEach(function (el) {
        if (!('IntersectionObserver' in window)) return el.classList.add('is-gorunur');
        var io = new IntersectionObserver(function (g) {
          if (g[0].isIntersecting) { el.classList.add('is-gorunur'); io.disconnect(); }
        }, { threshold: 0.25 });
        io.observe(el);
      });
    }
    function akordeon() {
      var genis = window.matchMedia('(min-width: 750px)');
      function uygula() {
        document.querySelectorAll('[data-bt-akordeon]').forEach(function (d) {
          if (genis.matches) d.setAttribute('open', '');
          else if (!d.dataset.btDokunuldu) d.removeAttribute('open');
        });
      }
      document.querySelectorAll('[data-bt-akordeon] > summary').forEach(function (s) {
        s.addEventListener('click', function () { s.parentElement.dataset.btDokunuldu = '1'; });
      });
      uygula();
      genis.addEventListener('change', uygula);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', akordeon);
    else akordeon();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { kur(); });
    else kur();
    document.addEventListener('shopify:section:load', function (e) { kur(e.target); akordeon(); if (window.btBelirKur) window.btBelirKur(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-hikaye"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-hikaye')) {
    customElements.define(
      'bt-hikaye',
      class extends HTMLElement {
        connectedCallback() {
          this.bolumler = Array.from(this.querySelectorAll('[data-bolum]'));
          this.adimlar = Array.from(this.querySelectorAll('[data-yol]'));
          this.dolgu = this.querySelector('.bt-hik__yol-dolgu');
          this.fotolar = Array.from(this.querySelectorAll('[data-paralaks]'));
          this.azHareket = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.aktif = -1;

          this.adimlar.forEach((a) =>
            a.addEventListener('click', (e) => {
              e.preventDefault();
              this.bolumler[Number(a.dataset.yol)]?.scrollIntoView({
                behavior: this.azHareket ? 'auto' : 'smooth',
                block: 'start',
              });
            })
          );

          this.kaydir = () => {
            if (this.kare) return;
            this.kare = requestAnimationFrame(() => {
              this.kare = null;
              this.guncelle();
            });
          };
          window.addEventListener('scroll', this.kaydir, { passive: true });
          this.boyut = () => {
            this.aktif = -1;
            this.kaydir();
          };
          window.addEventListener('resize', this.boyut);
          document.fonts?.ready.then(this.boyut);
          this.guncelle();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.kaydir);
          window.removeEventListener('resize', this.boyut);
        }

        guncelle() {
          const vh = window.innerHeight;
          const kutu = this.getBoundingClientRect();
          this.classList.toggle('is-icinde', kutu.top < vh * 0.35 && kutu.bottom > vh * 0.5);

          /* Ekranın ortasını geçen son bölüm aktiftir */
          let aktif = 0;
          this.bolumler.forEach((b, i) => {
            if (b.getBoundingClientRect().top < vh * 0.5) aktif = i;
          });
          if (aktif !== this.aktif) this.aktifYap(aktif);

          if (this.azHareket) return;
          this.fotolar.forEach((f) => {
            const r = f.getBoundingClientRect();
            if (r.bottom < 0 || r.top > vh) return;
            const oran = (r.top + r.height / 2 - vh / 2) / vh;
            f.style.setProperty('--paralaks', `${(oran * -36).toFixed(1)}px`);
          });
        }

        aktifYap(i) {
          this.aktif = i;
          this.adimlar.forEach((a, j) => {
            a.classList.toggle('is-aktif', j === i);
            if (j === i) a.setAttribute('aria-current', 'step');
            else a.removeAttribute('aria-current');
          });
          const a = this.adimlar[i];
          if (a && this.dolgu) {
            this.dolgu.style.setProperty('--dolgu-en', `${a.offsetWidth}px`);
            this.dolgu.style.setProperty('--dolgu-x', `${a.offsetLeft}px`);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-home-90-gun"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-cizelge')) {
    class BtCizelge extends HTMLElement {
      connectedCallback() {
        this.dolgu = this.querySelector('.bt-gun__dolgu');
        this.adimlar = Array.from(this.querySelectorAll('.bt-gun__adim'));
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.adimlar.forEach((a) => a.classList.add('is-gecildi'));
          return;
        }
        this.guncelle = this.guncelle.bind(this);
        this.planla = () => {
          if (this.bekliyor) return;
          this.bekliyor = true;
          requestAnimationFrame(() => {
            this.bekliyor = false;
            this.guncelle();
          });
        };
        document.addEventListener('scroll', this.planla, { passive: true, capture: true });
        window.addEventListener('resize', this.planla, { passive: true });
        this.guncelle();
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.planla, { capture: true });
        window.removeEventListener('resize', this.planla);
      }

      guncelle() {
        const r = this.getBoundingClientRect();
        const ekran = window.innerHeight;
        const esik = ekran * 0.6;
        const oran = Math.min(1, Math.max(0, (esik - r.top) / Math.max(1, r.height)));
        this.style.setProperty('--bt-ilerleme', oran.toFixed(3));
        this.adimlar.forEach((a) => {
          a.classList.toggle('is-gecildi', a.getBoundingClientRect().top < esik);
        });
      }
    }
    customElements.define('bt-cizelge', BtCizelge);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !matchMedia('(hover: hover)').matches) return;
    document.addEventListener('pointermove', function (e) {
      var sahne = e.target.closest && e.target.closest('[data-bt-hero-sahne]');
      document.querySelectorAll('[data-bt-hero-sahne] .bt-hero__foto-ic img').forEach(function (img) {
        if (!sahne) { img.style.translate = ''; return; }
        var r = sahne.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * -14;
        var y = ((e.clientY - r.top) / r.height - 0.5) * -14;
        img.style.translate = x.toFixed(1) + 'px ' + y.toFixed(1) + 'px';
      });
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-home-neden"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function kur(kok) {
      (kok || document).querySelectorAll('[data-bt-maske]:not(.is-gorunur)').forEach(function (el) {
        if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return el.classList.add('is-gorunur');
        var io = new IntersectionObserver(function (g) {
          if (g[0].isIntersecting) { el.classList.add('is-gorunur'); io.disconnect(); }
        }, { threshold: 0.4 });
        io.observe(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { kur(); });
    else kur();
    document.addEventListener('shopify:section:load', function (e) { kur(e.target); if (window.btBelirKur) window.btBelirKur(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-home-ritual"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-sekmeler')) {
    class BtSekmeler extends HTMLElement {
      connectedCallback() {
        this.sekmeler = Array.from(this.querySelectorAll('[role="tab"]'));
        this.sekmeler.forEach((sekme, i) => {
          sekme.addEventListener('click', () => this.sec(i, false));
          sekme.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            const n = this.sekmeler.length;
            const yeni = (i + (e.key === 'ArrowRight' ? 1 : -1) + n) % n;
            this.sec(yeni, true);
          });
        });
      }

      sec(i, odakla) {
        this.sekmeler.forEach((sekme, k) => {
          const secili = k === i;
          sekme.setAttribute('aria-selected', String(secili));
          sekme.tabIndex = secili ? 0 : -1;
          const panel = this.querySelector('#' + sekme.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !secili;
          if (secili) {
            panel.classList.remove('is-giris');
            void panel.offsetWidth;
            panel.classList.add('is-giris');
            const kaydir = panel.querySelector('.bt-kaydir');
            if (kaydir) kaydir.scrollLeft = 0;
          }
        });
        if (odakla) this.sekmeler[i].focus();
      }
    }
    customElements.define('bt-sekmeler', BtSekmeler);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-home-sac-tipi"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-sac-tipi')) {
    class BtSacTipi extends HTMLElement {
      connectedCallback() {
        this.secenekler = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panel = this.querySelector('[role="tabpanel"]');
        this.secenekler.forEach((s, i) => {
          s.addEventListener('click', () => this.sec(i, false));
          s.addEventListener('keydown', (e) => {
            const tuslar = { ArrowRight: 1, ArrowDown: 2, ArrowLeft: -1, ArrowUp: -2 };
            if (!(e.key in tuslar)) return;
            e.preventDefault();
            const n = this.secenekler.length;
            this.sec((i + tuslar[e.key] + n) % n, true);
          });
        });
      }

      sec(i, odakla) {
        this.secenekler.forEach((s, k) => {
          const secili = k === i;
          s.setAttribute('aria-selected', String(secili));
          s.tabIndex = secili ? 0 : -1;
        });
        const hedef = this.secenekler[i];
        this.panel.setAttribute('aria-labelledby', hedef.id);
        this.panel.querySelectorAll('[data-ipucu-id]').forEach((el) => {
          el.hidden = el.dataset.ipucuId !== hedef.dataset.ipucu;
        });
        if (odakla) hedef.focus();
        if (window.innerWidth < 990) {
          const r = this.panel.getBoundingClientRect();
          if (r.bottom > window.innerHeight) this.panel.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
        }
      }
    }
    customElements.define('bt-sac-tipi', BtSacTipi);

    document.addEventListener('shopify:block:select', (e) => {
      const kap = e.target.closest('bt-sac-tipi');
      if (!kap) return;
      const i = kap.secenekler.indexOf(e.target);
      if (i > -1) kap.sec(i, false);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-home-vitrin"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function kur(kok) {
      (kok || document).querySelectorAll('.bt-vitrin__maske:not(.is-gorunur)').forEach(function (el) {
        if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return el.classList.add('is-gorunur');
        var io = new IntersectionObserver(function (g) {
          if (g[0].isIntersecting) { el.classList.add('is-gorunur'); io.disconnect(); }
        }, { threshold: 0.2 });
        io.observe(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { kur(); });
    else kur();
    document.addEventListener('shopify:section:load', function (e) { kur(e.target); if (window.btBelirKur) window.btBelirKur(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-home-yolculuk"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-yolculuk')) {
    class BtYolculuk extends HTMLElement {
      connectedCallback() {
        this.adimlar = Array.from(this.querySelectorAll('.bt-yol__adim'));
        this.gorseller = Array.from(this.querySelectorAll('.bt-yol__sahne-gorsel'));
        if (!this.adimlar.length) return;
        this.aktif(0);
        if (!('IntersectionObserver' in window)) return;
        this.io = new IntersectionObserver(
          (girdiler) => {
            girdiler.forEach((g) => {
              if (g.isIntersecting) this.aktif(Number(g.target.dataset.sira));
            });
          },
          { rootMargin: '-45% 0px -45% 0px' }
        );
        this.adimlar.forEach((a) => this.io.observe(a));
      }

      disconnectedCallback() {
        this.io?.disconnect();
      }

      aktif(i) {
        this.adimlar.forEach((a, k) => a.classList.toggle('is-aktif', k === i));
        this.gorseller.forEach((g, k) => g.classList.toggle('is-aktif', k === i));
      }
    }
    customElements.define('bt-yolculuk', BtYolculuk);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-iade-adimlar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function kur(kok) {
      (kok || document).querySelectorAll('[data-bt-iade-yol]:not(.is-gorunur)').forEach(function (el) {
        el.style.setProperty('--bt-adim-sayisi', el.children.length);
        if (!('IntersectionObserver' in window)) return el.classList.add('is-gorunur');
        var io = new IntersectionObserver(function (g) {
          if (g[0].isIntersecting) { el.classList.add('is-gorunur'); io.disconnect(); }
        }, { threshold: 0.15 });
        io.observe(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { kur(); });
    else kur();
    document.addEventListener('shopify:section:load', function (e) { kur(e.target); if (window.btBelirKur) window.btBelirKur(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-iletisim-kanallar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-bt-kopyala]');
    if (!b) return;
    const metin = b.dataset.btKopyala;
    const yaz = () => {
      const span = b.querySelector('.bt-kanal__kopyala-metin');
      const eski = span.textContent;
      span.textContent = b.dataset.tamam;
      b.classList.add('is-tamam');
      setTimeout(() => {
        span.textContent = eski;
        b.classList.remove('is-tamam');
      }, 1800);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(metin).then(yaz).catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-kampanya"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-kampanya')) {
    class BtKampanya extends HTMLElement {
      connectedCallback() {
        // Bitiş: "YYYY-AA-GG SS:DD" (Türkiye saati)
        let ham = (this.dataset.bitis || '').trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(ham)) ham += 'T23:59:59+03:00';
        else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(ham)) ham = ham.replace(' ', 'T') + ':00+03:00';
        const bitis = new Date(ham);
        if (isNaN(bitis)) return;
        this.bitis = bitis.getTime();
        this.alanlar = {};
        this.querySelectorAll('[data-k]').forEach((el) => (this.alanlar[el.dataset.k] = el));
        if (!this.guncelle()) return;
        this.hidden = false;
        this.z = setInterval(() => {
          if (!this.guncelle()) {
            clearInterval(this.z);
            this.remove();
          }
        }, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.z);
      }

      guncelle() {
        const kalan = Math.floor((this.bitis - Date.now()) / 1000);
        if (kalan <= 0) {
          this.hidden = true;
          return false;
        }
        const iki = (n) => String(n).padStart(2, '0');
        this.alanlar.gun.textContent = Math.floor(kalan / 86400);
        this.alanlar.saat.textContent = iki(Math.floor((kalan % 86400) / 3600));
        this.alanlar.dk.textContent = iki(Math.floor((kalan % 3600) / 60));
        this.alanlar.sn.textContent = iki(kalan % 60);
        return true;
      }
    }
    customElements.define('bt-kampanya', BtKampanya);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-urun-icerik"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-ayrisma')) {
    class BtAyrisma extends HTMLElement {
      connectedCallback() {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.style.setProperty('--bt-ayri', '1');
          return;
        }
        this.planla = () => {
          if (this.bekliyor) return;
          this.bekliyor = true;
          requestAnimationFrame(() => {
            this.bekliyor = false;
            const r = this.getBoundingClientRect();
            const h = window.innerHeight;
            const oran = Math.min(1, Math.max(0, (h - r.top) / (h * 0.9)));
            this.style.setProperty('--bt-ayri', oran.toFixed(3));
          });
        };
        document.addEventListener('scroll', this.planla, { passive: true, capture: true });
        this.planla();
      }
      disconnectedCallback() {
        document.removeEventListener('scroll', this.planla, { capture: true });
      }
    }
    customElements.define('bt-ayrisma', BtAyrisma);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-urun-nasil"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-nasil-ray')) {
    customElements.define(
      'bt-nasil-ray',
      class extends HTMLElement {
        connectedCallback() {
          const ray = this.querySelector('[data-ray]');
          const cubuk = this.querySelector('[data-cubuk]');
          if (!ray || !cubuk) return;
          const guncelle = () => {
            const oran = Math.min(1, ray.clientWidth / ray.scrollWidth);
            const max = ray.scrollWidth - ray.clientWidth;
            const ilerleme = max > 0 ? ray.scrollLeft / max : 0;
            cubuk.style.setProperty('--bt-oran', `${oran * 100}%`);
            cubuk.style.setProperty('--bt-kayma', `${((1 - oran) / oran) * ilerleme * 100}%`);
          };
          ray.addEventListener('scroll', guncelle, { passive: true });
          window.addEventListener('resize', guncelle);
          guncelle();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-urun-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-reels')) {
    class BtReels extends HTMLElement {
      connectedCallback() {
        this.ray = this.querySelector('[data-ray]');
        this.kartlar = Array.from(this.querySelectorAll('[data-kart]'));
        if (!this.ray || !this.kartlar.length) return;
        this.noktalar = Array.from(this.querySelectorAll('[data-nokta]'));
        this.sayac = this.querySelector('[data-sayac]');
        this.azHareket = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.otomatik = this.dataset.otomatik === 'true' && this.kartlar.length > 1;
        this.ikiliSorgu = matchMedia('(max-width: 749px)');
        this.sesAcik = false;
        this.gorunur = false;
        this.aktif = -1;

        this.kartlar.forEach((kart, i) => {
          const video = kart.querySelector('video');
          kart.querySelector('.bt-reels__cerceve').addEventListener('click', (e) => {
            if (e.target.closest('[data-ses]')) return;
            if (i !== this.aktif) return this.git(i);
            if (!video) return;
            if (video.paused) this.oynat(kart, true);
            else {
              video.pause();
              kart.classList.add('is-durdu');
            }
          });
          if (!video) return;
          video.loop = !this.otomatik;
          video.addEventListener('ended', () => {
            if (this.otomatik && i === this.aktif) this.git(i + 1);
          });
          kart.querySelector('[data-ses]')?.addEventListener('click', () => {
            this.sesAcik = video.muted;
            this.kartlar.forEach((k) => this.sesAyarla(k, false));
            if (this.sesAcik) {
              if (i !== this.aktif) this.git(i);
              this.sesAyarla(kart, true);
              this.oynat(kart, true);
            }
          });
        });

        this.querySelectorAll('[data-git]').forEach((b) =>
          b.addEventListener('click', () => this.git(this.aktif + Number(b.dataset.git)))
        );
        this.noktalar.forEach((n) => n.addEventListener('click', () => this.git(Number(n.dataset.nokta))));
        this.querySelector('[data-satin-al]')?.addEventListener('click', (e) => {
          e.preventDefault();
          const hedef = document.querySelector('[data-sablon]') || document.querySelector('main');
          hedef?.scrollIntoView({ behavior: this.azHareket ? 'auto' : 'smooth', block: 'start' });
        });

        this.kaydirmaDinle = () => {
          if (this.kare) return;
          this.kare = requestAnimationFrame(() => {
            this.kare = null;
            this.hesapla();
          });
        };
        this.ray.addEventListener('scroll', this.kaydirmaDinle, { passive: true });
        this.boyutDinle = () => {
          this.classList.remove('is-sabit');
          this.sabit = this.ray.scrollWidth <= this.ray.clientWidth + 2;
          this.classList.toggle('is-sabit', this.sabit);
          this.hesapla();
        };
        window.addEventListener('resize', this.boyutDinle);

        this.blokSec = (e) => {
          const i = this.kartlar.findIndex((k) => k.dataset.blok === e.detail?.blockId);
          if (i > -1) this.git(i);
        };
        document.addEventListener('shopify:block:select', this.blokSec);

        this.boyutDinle();
        if (this.sabit) this.aktifYap(Math.floor((this.kartlar.length - 1) / 2));

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            ([g]) => {
              this.gorunur = g.isIntersecting;
              if (g.isIntersecting) this.classList.add('is-gorunur');
              const kart = this.kartlar[this.aktif];
              if (!kart) return;
              if (this.gorunur && !kart.classList.contains('is-durdu')) this.oynat(kart);
              else if (!this.gorunur) this.durdurHepsi();
            },
            { threshold: 0.35 }
          );
          this.io.observe(this);
        } else {
          this.classList.add('is-gorunur');
          this.gorunur = true;
        }
      }

      disconnectedCallback() {
        this.io?.disconnect();
        window.removeEventListener('resize', this.boyutDinle);
        document.removeEventListener('shopify:block:select', this.blokSec);
        cancelAnimationFrame(this.ilerlemeKare);
      }

      /* Kartların merkeze uzaklığına göre 3B açı, ölçek ve ışık */
      hesapla() {
        if (this.sabit) {
          const a = Math.max(this.aktif, 0);
          const orta = (this.kartlar.length - 1) / 2;
          const adim = this.kartlar[0].offsetWidth + 8;
          this.ray.style.setProperty('--kaydir', `${(orta - a) * adim}px`);
          this.kartlar.forEach((k, i) => this.uzaklik(k, i - a));
          return;
        }
        this.ray.style.removeProperty('--kaydir');
        if (this.ikiliSorgu.matches) return this.ikiliHesapla();
        const merkez = this.ray.scrollLeft + this.ray.clientWidth / 2;
        let enYakin = 0;
        let enAz = Infinity;
        this.kartlar.forEach((k, i) => {
          const d = (k.offsetLeft + k.offsetWidth / 2 - merkez) / (k.offsetWidth + 14);
          this.uzaklik(k, d);
          if (Math.abs(d) < enAz) {
            enAz = Math.abs(d);
            enYakin = i;
          }
        });
        if (enYakin !== this.aktif) this.aktifYap(enYakin);
      }

      /* Mobil ikili düzen: soldaki tam görünen kart aktiftir; sonda görünen son kart da aktif olabilir */
      ikiliHesapla() {
        this.kartlar.forEach((k) => this.uzaklik(k, 0));
        if (this.kilit) return;
        const r = this.ray.getBoundingClientRect();
        const sol = parseFloat(getComputedStyle(this.ray).paddingLeft) || 0;
        let bas = 0;
        let enAz = Infinity;
        this.kartlar.forEach((k, i) => {
          const fark = Math.abs(k.getBoundingClientRect().left - r.left - sol);
          if (fark < enAz) {
            enAz = fark;
            bas = i;
          }
        });
        const sonda = this.ray.scrollLeft >= this.ray.scrollWidth - this.ray.clientWidth - 4;
        if (sonda && this.aktif > bas) return;
        if (bas !== this.aktif) this.aktifYap(bas);
      }

      uzaklik(kart, d) {
        const s = Math.max(-1.4, Math.min(1.4, d));
        kart.style.setProperty('--d', s.toFixed(3));
        kart.style.setProperty('--ad', Math.min(1, Math.abs(s)).toFixed(3));
      }

      git(i) {
        const n = this.kartlar.length;
        const hedef = ((i % n) + n) % n;
        if (this.sabit) return this.aktifYap(hedef);
        const k = this.kartlar[hedef];
        if (this.ikiliSorgu.matches) {
          const sol = parseFloat(getComputedStyle(this.ray).paddingLeft) || 0;
          const hedefSol = this.ray.scrollLeft + k.getBoundingClientRect().left - this.ray.getBoundingClientRect().left - sol;
          this.kilit = true;
          clearTimeout(this.kilitSure);
          this.kilitSure = setTimeout(() => (this.kilit = false), 900);
          this.aktifYap(hedef);
          this.ray.scrollTo({ left: hedefSol, behavior: this.azHareket ? 'auto' : 'smooth' });
          return;
        }
        this.ray.scrollTo({
          left: k.offsetLeft - (this.ray.clientWidth - k.offsetWidth) / 2,
          behavior: this.azHareket ? 'auto' : 'smooth',
        });
      }

      aktifYap(i) {
        const onceki = this.aktif;
        this.aktif = i;
        this.kartlar.forEach((k, j) => k.classList.toggle('is-aktif', j === i));
        this.noktalar.forEach((n, j) => {
          n.classList.toggle('is-aktif', j === i);
          n.setAttribute('aria-current', j === i ? 'true' : 'false');
          n.style.setProperty('--bt-ilerleme', 1);
        });
        if (this.sayac && onceki !== i) {
          this.sayac.textContent = String(i + 1).padStart(2, '0');
          this.sayac.classList.remove('is-degis');
          void this.sayac.offsetWidth;
          this.sayac.classList.add('is-degis');
        }
        if (this.sabit) this.hesapla();

        this.durdurHepsi(i);
        const kart = this.kartlar[i];
        const video = kart.querySelector('video');
        if (!video) return;
        if (this.noktalar[i]) this.noktalar[i].style.setProperty('--bt-ilerleme', 0);
        kart.classList.remove('is-durdu');
        if (onceki !== -1) video.currentTime = 0;
        if (this.gorunur && (!this.azHareket || this.sesAcik)) this.oynat(kart);
        else kart.classList.add('is-durdu');
      }

      durdurHepsi(haric = -1) {
        this.kartlar.forEach((k, j) => {
          if (j === haric) return;
          const v = k.querySelector('video');
          if (!v) return;
          v.pause();
          this.sesAyarla(k, false);
        });
      }

      oynat(kart, kullanici = false) {
        const video = kart.querySelector('video');
        if (!video) return;
        if (this.azHareket && !kullanici && !this.sesAcik) {
          kart.classList.add('is-durdu');
          return;
        }
        if (video.preload === 'none') video.preload = 'auto';
        this.sesAyarla(kart, this.sesAcik);
        kart.classList.remove('is-durdu');
        video.play().then(
          () => this.ilerlemeBaslat(kart),
          () => {
            if (!video.muted) {
              this.sesAyarla(kart, false);
              video.play().then(() => this.ilerlemeBaslat(kart), () => kart.classList.add('is-durdu'));
            } else kart.classList.add('is-durdu');
          }
        );
      }

      /* İlerleme çubuğu ve aktif nokta, video ile akıcı biçimde dolar */
      ilerlemeBaslat(kart) {
        cancelAnimationFrame(this.ilerlemeKare);
        const video = kart.querySelector('video');
        const cubuk = kart.querySelector('.bt-reels__ilerleme');
        const nokta = this.noktalar[this.kartlar.indexOf(kart)];
        const adim = () => {
          if (video.duration) {
            const o = (video.currentTime / video.duration).toFixed(4);
            cubuk?.style.setProperty('--bt-ilerleme', o);
            nokta?.style.setProperty('--bt-ilerleme', o);
          }
          if (!video.paused && !video.ended) this.ilerlemeKare = requestAnimationFrame(adim);
        };
        adim();
      }

      sesAyarla(kart, acik) {
        const video = kart.querySelector('video');
        const ses = kart.querySelector('[data-ses]');
        if (!video || !ses) return;
        video.muted = !acik;
        ses.setAttribute('aria-pressed', String(acik));
        ses.setAttribute('aria-label', acik ? ses.dataset.kapatEtiket : ses.dataset.acEtiket);
      }
    }
    customElements.define('bt-reels', BtReels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-urun-sss"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-sss')) {
    customElements.define(
      'bt-sss',
      class extends HTMLElement {
        connectedCallback() {
          this.azHareket = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.satirlar = Array.from(this.querySelectorAll('details'));
          this.satirlar.forEach((d) => {
            if (d.open) d.classList.add('is-acik');
            d.querySelector('summary').addEventListener('click', (e) => {
              e.preventDefault();
              if (d.open) this.kapat(d);
              else {
                this.satirlar.forEach((x) => x !== d && x.open && this.kapat(x));
                this.ac(d);
              }
            });
          });
          this.querySelector('[data-daha]')?.addEventListener('click', (e) => {
            this.classList.remove('is-kisa');
            this.querySelectorAll('.bt-sss__satir--ek').forEach((d, i) => {
              d.style.setProperty('--bt-sira', i);
              d.classList.add('is-yeni', 'is-gorunur');
            });
            e.currentTarget.setAttribute('aria-expanded', 'true');
          });
          document.addEventListener('shopify:block:select', (e) => {
            const d = this.satirlar.find((x) => x.contains(e.target));
            if (!d) return;
            this.classList.remove('is-kisa');
            if (!d.open) this.ac(d);
          });
        }

        /* Yükseklik akıcı açılır; cevap bulanıktan netleşerek belirir */
        ac(d) {
          const govde = d.querySelector('.bt-sss__govde');
          govde.getAnimations().forEach((x) => x.cancel());
          d.open = true;
          requestAnimationFrame(() => d.classList.add('is-acik'));
          if (this.azHareket) return;
          const h = govde.scrollHeight;
          govde.animate([{ height: '0px' }, { height: `${h}px` }], {
            duration: 520,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          });
        }

        kapat(d) {
          const govde = d.querySelector('.bt-sss__govde');
          d.classList.remove('is-acik');
          if (this.azHareket) {
            d.open = false;
            return;
          }
          const a = govde.animate([{ height: `${govde.offsetHeight}px` }, { height: '0px' }], {
            duration: 380,
            easing: 'cubic-bezier(0.45, 0, 0.2, 1)',
            fill: 'forwards',
          });
          const bitir = () => {
            if (!d.classList.contains('is-acik')) d.open = false;
            a.cancel();
          };
          a.onfinish = bitir;
          setTimeout(bitir, 420);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["batanova-urun-yorumlar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-daha-fazla')) {
    class BtDahaFazla extends HTMLElement {
      connectedCallback() {
        // Öğe, içi henüz yüklenmeden tanımlanabilir; bu yüzden tıklamayı kökten dinle
        this.addEventListener('click', (e) => {
          const b = e.target.closest('[data-daha]');
          if (!b) return;
          const adim = Number(this.dataset.adet) || 3;
          const gizli = Array.from(this.querySelectorAll('.is-gizli')).slice(0, adim);
          gizli.forEach((k) => {
            k.classList.remove('is-gizli');
            k.classList.add('is-gorunur');
          });
          gizli[0]?.setAttribute('tabindex', '-1');
          gizli[0]?.focus({ preventScroll: true });
          if (!this.querySelector('.is-gizli')) b.remove();
        });
      }
    }
    customElements.define('bt-daha-fazla', BtDahaFazla);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
